import { useIntl } from 'react-intl'
import { AsideMenuItem } from './AsideMenuItem'

/*Tradução */
import '../../../../i18n/config';
import { useTranslation } from 'react-i18next';

export function AsideMenuAdmin({ planos, urlTreinamento, controlaClientes, usuarioInterno }: { planos: string[], urlTreinamento?: string, controlaClientes?: boolean, usuarioInterno?: boolean }) {
  const intl = useIntl()
  const { t } = useTranslation();

  const temPlanoEnterprise = (planos ?? []).includes('Plano Enterprise')
  const bloqueadoEnterprise = !temPlanoEnterprise

  return (
    <>
      <AsideMenuItem
        to='/empresas'
        title={intl.formatMessage({ id: t('MENU.EMPRESAS') })}
        fontIcon='bi bi-bag'
      />
      <AsideMenuItem
        to='/usuarios'
        title={intl.formatMessage({ id: t('MENU.USERS') })}
        fontIcon='bi bi-people'
      />
      {/* DEVN3-627: chaves da API pública. Ainda não liberado aos clientes (a API pública está
          em construção — US DEVN3-623) — só usuários @ainumera.com, mesma regra em PrivateRoutes. */}
      {usuarioInterno && (
        <AsideMenuItem
          to='/api-keys'
          title='API Key'
          fontIcon='bi bi-key'
        />
      )}
      <AsideMenuItem
        to='/importar'
        title={intl.formatMessage({ id: t('MENU.IMPORTAR') })}
        fontIcon='fas fa-upload'
      />

      {/* Importar Razão Universal ainda não liberado aos clientes — só usuários @ainumera.com (DEVN3-600). */}
      {usuarioInterno && (
        <AsideMenuItem
          to='/importar-razao'
          title={intl.formatMessage({ id: t('MENU.IMPORTAR_RAZAO') })}
          fontIcon='fas fa-file-excel'
        />
      )}

      <AsideMenuItem
        to='/integracao'
        title={t('Integração')}
        fontIcon='fas fa-upload'
      />

      <AsideMenuItem
        to='/modulo-bancario'
        title={t('Módulo Bancário')}
        fontIcon='fas fa-university'
        badge='Novo'
      />

      <AsideMenuItem
        to='/andamento-contas'
        title={t('Mapa de conciliação')}
        fontIcon='bi bi-pie-chart'
      />

      <AsideMenuItem
        to='/andamento-contas-resultado'
        title={t('Mapa de Resultado')}
        fontIcon='bi bi-pie-chart'
        badge='Novo'
        bloqueado={bloqueadoEnterprise}
      />

      {/* {(especial || tipoAssinatura.toLocaleLowerCase().includes("smart")) && (
        <AsideMenuItem
          to='/mapa-resultado'
          title={t('Mapa de Resultado')}
          fontIcon='bi bi-pie-chart'
        />
      )} */}

      <AsideMenuItem
        to='/relatorioSelecionarCliente'
        title={intl.formatMessage({ id: t('MENU.RELATORIOS') })}
        fontIcon='bi bi-pie-chart'
      />

      <AsideMenuItem
        to='/dashboard'
        title='Dashboard'
        fontIcon='bi bi-pie-chart'
      />

      {/* Auditoria não é mais bloqueada por Plano Enterprise no menu — o controle de acesso real
          é por tier (auditoria/meu-acesso), verificado dentro de AuditoriaPage. Bloquear aqui
          também, com um critério diferente e desatualizado, impedia o usuário de sequer chegar
          na página onde o tier configurado no painel do cliente é respeitado. */}
      <AsideMenuItem
        to='/auditoria'
        title={t('Auditoria')}
        fontIcon='bi bi-search'
        badge='Novo'
      />

      {/* Workflow SOX não é bloqueado por Plano Enterprise no menu — controle de acesso real é
          por permissão (Administrador TI), verificado dentro do próprio módulo. Bloquear aqui
          impedia o usuário de sequer chegar na tela e caía no popup genérico de "agendar
          demonstração", que não faz sentido para um módulo de configuração interna. */}
      <AsideMenuItem
        to='/workflow-aprovacao'
        title={t('Workflow SOX')}
        fontIcon='bi bi-diagram-3'
        badge='Novo'
      />

      <AsideMenuItem
        to='/maestro-contabil'
        title={t('Maestro Contábil')}
        fontIcon='bi bi-bar-chart-steps'
        badge='Novo'
      />

      <AsideMenuItem
        external
        to={urlTreinamento || ''}
        title={t('Tutoriais')}
        fontIcon='bi bi-mortarboard'
      />
      {/* <AsideMenuItem
        to={controlaClientes ? '/suporte-interno' : '/suporte'}
        title={t('Suporte')}
        fontIcon='bi bi-headset'
      /> */}
    </>
  )
}